const SOURCE_TOKEN = 'bold_stand';

const state = {
  isSubmitting: false,
};

const selectors = {
  cartForm: '[data-bs-cart-form]',
};

function $$(sel, root = document) {
  return Array.from(root.querySelectorAll(sel));
}

function setBusy(busy) {
  state.isSubmitting = busy;
  $$(selectors.cartForm).forEach((form) => {
    $$('button', form).forEach((btn) => {
      btn.disabled = busy;
    });
  });
}

async function cleanupExistingBoldStandItems() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return;
    const cart = await res.json();
    const items = (cart && cart.items) || [];
    const toRemove = items.filter(
      (item) => item.properties && item.properties._source === SOURCE_TOKEN
    );

    for (const item of toRemove) {
      try {
        // Form-encoded body (not JSON) so Cloudflare's bot heuristics
        // score this like a normal browser form submission — JSON POSTs
        // to /cart/* endpoints have been 403'd on this store before.
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            id: String(item.key),
            quantity: '0',
          }),
        });
      } catch (err) {
        console.warn('[bold-stand-checkout] failed to remove line', item.key, err);
      }
    }
  } catch (err) {
    console.warn('[bold-stand-checkout] cleanup skipped', err);
  }
}

async function onFormSubmit(event) {
  if (state.isSubmitting) {
    event.preventDefault();
    return;
  }
  event.preventDefault();
  const form = event.currentTarget;
  setBusy(true);

  // The selector appears three times on the page (hero, intro, final
  // CTA) with nothing gating re-clicks, so swap — don't stack — any
  // prior bold-stand line before adding the newly chosen one. If
  // cleanup fails (transient network error) we still submit so the
  // customer isn't blocked.
  try {
    await cleanupExistingBoldStandItems();
  } finally {
    form.submit();
  }
}

function prewarmCart() {
  // Fire-and-forget GET on page load to establish the cart session
  // cookie before any user interaction. Helps the cleanup POST in
  // onFormSubmit succeed on the first click instead of hitting
  // Cloudflare's first-POST challenge.
  fetch('/cart.js', { credentials: 'same-origin' }).catch(() => {});
}

// Capture UTM parameters from URL on first landing and persist for
// the duration of the tab session. URL params get dropped when the
// form POSTs to /cart/add → /checkout, so sessionStorage is what
// keeps them alive across navigation (including bfcache back-trips).
function captureUTMs() {
  const KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const params = new URLSearchParams(window.location.search);
  const utms = {};

  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utms[k] = v;
  });

  if (Object.keys(utms).length > 0) {
    try {
      sessionStorage.setItem('boldStandUTMs', JSON.stringify(utms));
    } catch (_) {}
  } else {
    try {
      Object.assign(utms, JSON.parse(sessionStorage.getItem('boldStandUTMs') || '{}'));
    } catch (_) {}
  }

  return utms;
}

// Append hidden `attributes[utm_*]` inputs to every bold-stand cart
// form. Shopify's /cart/add endpoint reads these as cart attributes,
// which carry through to /checkout and end up on the order as
// note_attributes — visible in admin "Additional details" and in
// order exports / webhooks for attribution reporting.
function injectUTMsIntoForms() {
  const utms = captureUTMs();
  const keys = Object.keys(utms);
  if (keys.length === 0) return;

  $$(selectors.cartForm).forEach((form) => {
    keys.forEach((key) => {
      const name = `attributes[${key}]`;
      if (form.querySelector(`input[name="${name}"]`)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = utms[key];
      form.appendChild(input);
    });
  });
}

function resetOnBfcacheRestore(event) {
  // When the user navigates back from /checkout on mobile, iOS Safari
  // and Chrome restore the page from bfcache with the buttons still
  // disabled from the submit. Detect the restore and re-enable them.
  if (!event.persisted) return;
  setBusy(false);
}

function init() {
  const forms = $$(selectors.cartForm);
  if (forms.length === 0) return;
  forms.forEach((form) => form.addEventListener('submit', onFormSubmit));
  window.addEventListener('pageshow', resetOnBfcacheRestore);
  injectUTMsIntoForms();
  prewarmCart();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => {
  $$(selectors.cartForm, event.target).forEach((form) =>
    form.addEventListener('submit', onFormSubmit)
  );
});
